import { LoadingOutlined } from '@ant-design/icons'
import { Button, Input, Result, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../../services/backend'
import { TamigoApiSecret } from '../../types'
import { notificationAction } from '../../../../../../redux/middleware/actions'
import { AppDispatch } from '../../../../../../redux/store'
import DataUpdate from '../../dataUpdate'

const TamigoApi: React.FC = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)
  const getCredentials = useBackend(`/tamigo/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const setCredentials = useBackend(`/tamigo/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)

  const dispatch: AppDispatch = useDispatch()

  const [apiKey, setApiKey] = useState<string>()
  const [name, setName] = useState<string>()
  const [authorized, setAuthorized] = useState(false)

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then((credentials: TamigoApiSecret) => {
        if (credentials.apiKey) {
          setApiKey(credentials.apiKey)
          setName(credentials.name)
          credentials.apiKey ? setAuthorized(true) : setAuthorized(false)
        } else {
          setApiKey('')
          setName('')
          setAuthorized(false)
        }
      })
      .catch(() => {
        setApiKey('')
        setName('')
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  const submit = () => {
    setCredentials
      .put({
        urlParams: { companyId },
        body: {
          data: {
            apiKey,
            name
          }
        }
      })
      .then((credentials: TamigoApiSecret) => {
        setApiKey(credentials.apiKey)
        setName(credentials.name)
        setAuthorized(true)
        dispatch(
          notificationAction({
            type: 'success',
            message: 'AUTHENTICATION_SUCCESS'
          })
        )
      })
      .catch(() => {
        setAuthorized(false)
        dispatch(
          notificationAction({
            type: 'error',
            message: 'AUTHENTICATION_ERROR',
            description: 'USERNAME_PASSWORD_MISMATCH'
          })
        )
      })
  }

  const emptyCredentials = () => {
    setApiKey('')
    setName('')
    setAuthorized(false)
  }

  if (authorized) {
    return (
      <>
        <Result
          status="success"
          title={t('integrationsPage:authenticated')}
          extra={
            <>
              <Button onClick={emptyCredentials} type="primary">
                {t('integrationsPage:authenticate')}
              </Button>
              <DataUpdate page="tamigo" />
            </>
          }
        />
      </>
    )
  }
  return (
    <Form layout="vertical">
      <Form.Item style={{ marginTop: 10 }} label={t('global:name')}>
        <Input
          value={name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item style={{ marginTop: 10 }} label="ApiKey">
        <Input
          value={apiKey}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setApiKey(event.target.value)}
          suffix={getCredentials.loading && <LoadingOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <Button.Group>
          <Button type="primary" onClick={() => submit()} loading={setCredentials.loading}>
            {t('integrationsPage:authorize')}
          </Button>
        </Button.Group>
      </Form.Item>
    </Form>
  )
}

export default TamigoApi
